import React, { useEffect, useState } from 'react';
import ContactForm from '@components/resident/CommonContacForm';
import useResidentDetailsFetch from '@hooks/useResidentDetailsFetch';
import { useParams } from 'react-router-dom';
import { NextOfKinDetails, ContactInfoType } from '@typings/ResidentTypes';
import { LpaType } from '../../utils';

interface LpaContactProps {
  lpa: LpaType;
  setLpa: React.Dispatch<React.SetStateAction<LpaType>>;
  lpaFromData: LpaType;
}

const LpaContact: React.FC<LpaContactProps> = ({
  lpa,
  setLpa,
  lpaFromData,
}) => {
  const [nextOfKinDetails, setNextOfKinDetails] = useState<NextOfKinDetails>({
    fullName: '',
    relationship: '',
    phoneNumber: '',
  });
  const [contactInfo, setContactInfo] = useState<ContactInfoType>({
    fullName: '',
    email: '',
    phoneNumber: '',
    relationship: '',
  });

  const { id: slug } = useParams<{ id: string }>();

  const { residentDetails } = useResidentDetailsFetch(slug);

  useEffect(() => {
    setLpa(prev => ({
      ...prev,
      lpaInfo: { ...prev.lpaInfo, lpaContact: { ...contactInfo } },
    }));
  }, [contactInfo, setLpa]);

  useEffect(() => {
    setContactInfo(lpaFromData.lpaInfo.lpaContact);
  }, [lpaFromData]);

  return (
    <div className="govuk-form-group mt-2 govuk-bp:mt-5">
      <h1 className="govuk-label-wrapper">
        <label className="govuk-label govuk-label--l" htmlFor="lpa-contact">
          Lasting Power of Attorney for Health and Welfare - Telephone contact
        </label>
      </h1>
      <div id="lpa-contact-hint" className="govuk-hint">
        What is the preferred telephone contact stated on the Lasting power of
        attorney for health and welfare document?
      </div>
      <ContactForm
        residentDetails={residentDetails}
        nextOfKinDetails={nextOfKinDetails}
        setNextOfKinDetails={setNextOfKinDetails}
        contactInfo={contactInfo}
        setContactInfo={setContactInfo}
      />
    </div>
  );
};

export default LpaContact;
